import { type ClientDayPlanOverride } from "~/features/day-plan/cookie.server";
import type { User } from "~/features/session/schemas";
import { CONDUCTOR_POSITIONS, DRIVER_POSITIONS } from "~/utils/constants";

export const isConductor = (user: Pick<User, "positions">) =>
  user.positions.some((it) => CONDUCTOR_POSITIONS.includes(it.code));

export const isDriver = (user: Pick<User, "positions">) =>
  user.positions.some((it) => DRIVER_POSITIONS.includes(it.code));

export const resolveEmployeeNumber = (
  employeeNumber?: string,
  override?: ClientDayPlanOverride,
) => override?.employeeNumber ?? employeeNumber;
